/**
 * Map license categories to localization keys.
 * This needs to be kept in sync with the backend configs/category.js, as new categories are added.
 */
export const LICENSE_CATEGORY_TO_LOCALIZATION_KEY = [
  ['m', 'category_m'],
  ['am', 'category_am'],
  ['t', 'category_t'],
  ['a', 'category_a'],
  ['b', 'category_b'],
  ['be', 'category_be'],
  ['c1', 'category_c1'],
  ['c1e', 'category_c1e'],
  ['d1', 'category_d1'],
  ['d1e', 'category_d1e'],
  ['c', 'category_c'],
  ['ce', 'category_ce'],
  ['d', 'category_d'],
  ['de', 'category_de'],
  ['taxi', 'category_taxi'],
  ['cpc', 'category_cpc'],
  ['adr', 'category_adr']
];
